import MapConfig from "../utils/map-config.json"; 

const HelpControl = () => {

  return (
    <div className="help-container">
      <div className="help-widgets">
        {MapConfig.Help.map((item, i) => (
          <div className="help-widgets-item" key={i}>
            <div className="help-widgets-image">
              <button className="ccl-button ccl-button--default ccl-button--default-neg map-button" aria-label={item.title + " icon"}>
                {
                  item.title === "Basemaps" ?
                  <div className="basemap-icon">
                    {Array.from({ length: 4 }, (_, i) => <i className={item.icon} key={i}></i>)}
                  </div>
                  : <i className={item.icon}></i>
                }
              </button>
            </div>
            <div className="help-widgets-text">
              <div className="help-widgets-title">
                {item.title}
              </div>
                <div className="help-widgets-description">
                  {item.description}
                </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HelpControl;
